export const API_ROUTES = {
  NOTIFICATIONS_LIST: {
    METHOD: 'POST',
    URL: 'system-notification/list',
  },
  NOTIFICATIONS_UNREAD_COUNT: {
    METHOD: 'GET',
    URL: 'system-notification/unread-count',
  },
  NOTIFICATION_MARK_READ: {
    METHOD: 'PUT',
    URL: 'system-notification',
  },
  NOTIFICATIONS_MARK_ALL_READ: {
    METHOD: 'PUT',
    URL: 'system-notification/read-all',
  },
  NOTIFICATION_DELETE: {
    METHOD: 'DELETE',
    URL: 'system-notification',
  },
  NOTIFICATIONS_CLEAR_READ: {
    METHOD: 'DELETE',
    URL: 'system-notification/clear-read',
  },
  DOWNLOAD_JOB_DOWNLOAD: {
    METHOD: 'GET',
    URL: 'download-job',
  },
};

/**
 * How often the header bell asks for its unread count. A background poll that
 * runs for every signed-in operator all day is the wrong place to chase
 * latency, so it is deliberately slow; the faster poll below takes over
 * whenever the user is actually waiting on a job, and opening the panel
 * refetches immediately.
 */
export const UNREAD_POLL_INTERVAL_MS = 5 * 60 * 1000;

/**
 * While a download is still being built the bell polls faster, because the
 * user is usually sitting and waiting for exactly that row to turn green.
 */
export const ACTIVE_JOB_POLL_INTERVAL_MS = 5000;

export const NOTIFICATION_TYPE_FILTERS = [
  { label: 'All', value: '' },
  { label: 'Downloads', value: 'download' },
  { label: 'Alerts', value: 'alert' },
];

/**
 * Maps a notification's severity onto a theme colour name. The row uses it for
 * both the icon tint (bg--<tone>-100) and the icon itself (text--<tone>), so
 * the two can never disagree.
 */
export const SEVERITY_TONE = {
  success: 'success',
  warning: 'warning',
  error: 'danger',
  info: 'primary',
};
